import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const ServicesSection = ({ t }) => {
  const services = t.services.items || [];
  const service0 = services[0] || {};
  const service1 = services[1] || {};
  const service2 = services[2] || {};

  const serviceImages = [
    'https://images.unsplash.com/photo-1484406566174-9da000fda645?w=600&q=80',
    'https://images.unsplash.com/photo-1588204812874-5a94f1d63439?w=600&q=80',
    'https://images.unsplash.com/photo-1616889638982-b06121164c3d?w=600&q=80'
  ];

  const renderService = (service, index) => {
    const features = service.features || [];
    return (
      <Card 
        key={index}
        className="bg-stone-900 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105 overflow-hidden group"
      >
        <div className="relative h-48 overflow-hidden">
          <img
            src={serviceImages[index]}
            alt={service.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-900 to-transparent"></div>
        </div>
        
        <CardHeader>
          <CardTitle className="text-2xl text-orange-500">
            {service.name}
          </CardTitle>
          <CardDescription className="text-gray-300 text-base">
            {service.description}
          </CardDescription>
        </CardHeader>
        
        <CardContent>
          <ul className="space-y-3">
            {features[0] && (
              <li className="flex items-start text-gray-300">
                <CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[0]}</span>
              </li>
            )}
            {features[1] && (
              <li className="flex items-start text-gray-300">
                <CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[1]}</span>
              </li>
            )}
            {features[2] && (
              <li className="flex items-start text-gray-300">
                <CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[2]}</span>
              </li>
            )}
            {features[3] && (
              <li className="flex items-start text-gray-300">
                <CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[3]}</span>
              </li>
            )}
          </ul>
        </CardContent>
      </Card>
    );
  };

  return (
    <section id="services" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.services.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {renderService(service0, 0)}
          {renderService(service1, 1)}
          {renderService(service2, 2)}
        </div>
      </div>
    </section>
  );
};
